import React, { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import PlayerChallenges from './challenges/challenges.component'
import PlayerHomeContent from './player-blocks/player-home-content.component'
import PlayerRewards from './rewards/rewards.component'
import './player-game-content.styles.scss'
import PlayerSideMenu from './side-menu.component'
import { useDispatch, useSelector } from 'react-redux'
import NewRewardModal from './player-blocks/modals/new-reward-modal.component'
import SubmitCode from './submit-code/submit-code.component'
import MyXpEarningsList from './player-blocks/components/status-elements/xp/my-xp-earnings-list.component'
import MyBadges from './player-blocks/components/status-elements/badges/my-badges.component'
import MyLevelsList from './player-blocks/components/status-elements/levels/my-levels-list.component'
import MyCurrencyEarningsList from './player-blocks/components/status-elements/currency/my-currency-earnings-list.component'
import MySecretCodesList from './player-blocks/components/status-elements/secret-codes/secret-codes-list.component'
import MyChallengesList from './player-blocks/components/status-elements/challenges/my-challenges-list.component'
import MyQuestsList from './player-blocks/components/status-elements/quests/my-quests-list.component'
import MyMomentumList from './player-blocks/components/status-elements/momentum/my-momentum-list.component'
import PlayerLeaderboardsContainer from './leaderboards/player-leaderboards-container.component'
import PlayerMarketLanding from './store/player-market-landing.component'
import InventoryLanding from './inventory/inventory-landing.component'
import DeclinedChallengeModal from './player-blocks/modals/approved-declined-modal.component'
import TransactionView from '../SHARED/transaction-view/transaction-view.component'
import MobilePlayerHomeContent from './player-blocks/mobile-player-home-content.component'
import ElementView from './player-blocks/components/status-elements/element-view.component'
import PlayerActivity from './activity/player-activity.component'
import PlayerTeamsView from './teams/player-teams-view.component'
import PlayerQuestsLanding from './quests/quests-landing.component'
import MomentumRevealModal from './player-blocks/modals/momentum-reveal-modal.component'
import TradeOfferNotificationModal from './player-blocks/modals/trade-offer-notification-modal.component'
import TradePortalContainer from '../SHARED/trade-portal/trade-portal-container.component'
import LootKeysLanding from './loot-keys/loot-keys-landing.component'
import MyLootKeysList from './player-blocks/components/status-elements/lootkeys/my-loot-keys-list.component'
import PlayerGameNews from './game-news/player-game-news.component'

const PlayerGameContent = ({
  gameData,
  playerData,
  updatePlayerData,
  gameElements,
  actionItems,
  gameStats,
  playerList,
  teamMembers,
  myTeams,
  gameMessages,
  unadjustedPlayerData
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const dispatch = useDispatch();
  const location = useLocation();
  const [momentumRevealQueue, setMomentumRevealQueue] = useState([]);

  function handleMomentumTriggered(ids) {
    setMomentumRevealQueue(prev => [...prev, ...ids]);
  }
  function handleMomentumDismiss() {
    setMomentumRevealQueue(prev => prev.slice(1));
  }

  // useDocumentTitle(gameData.gameName, gameData.icon);

  useEffect(() => {
    const playerGameContentDiv = document.querySelector('.game-content');
    if (playerGameContentDiv) {
      playerGameContentDiv.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location])

  return (
    <div
      className={`player-game-content ${screenSize}`}
    >
      {
        (playerData) &&
        <>
          {
            (
              screenSize !== 'mobile' &&
              screenSize !== 'tablet'
            ) &&
            <div className="side-menu-container">
              <div className='g-card'>
                <PlayerSideMenu
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                  teamMembers={teamMembers}
                />
              </div>
            </div>
          }
          <div className={`game-content ${screenSize}`} id='scroll-to-top'>
            <Routes>
              <Route path='' element={
                (screenSize === 'mobile' || screenSize === 'tablet') ?
                  <MobilePlayerHomeContent
                    gameData={gameData}
                    playerData={playerData}
                    gameElements={gameElements}
                    gameStats={gameStats}
                    actionItems={actionItems}
                    playerList={playerList}
                    gameMessages={gameMessages}
                    teamMembers={teamMembers}
                  />
                  :
                  <PlayerHomeContent
                    gameData={gameData}
                    playerData={playerData}
                    gameElements={gameElements}
                    gameStats={gameStats}
                    actionItems={actionItems}
                    playerList={playerList}
                    gameMessages={gameMessages}
                    teamMembers={teamMembers}
                  />
              }></Route>
              <Route path='inventory/*' element={
                <InventoryLanding
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                  gameStats={gameStats}
                  teamMembers={teamMembers}
                  myTeams={myTeams}
                  unadjustedPlayerData={unadjustedPlayerData}
                />
              }></Route>
              <Route path='rewards' element={
                <PlayerRewards
                  gameData={gameData}
                  playerData={playerData}
                  updatePlayerData={updatePlayerData}
                  gameElements={gameElements}
                  onMomentumTriggered={handleMomentumTriggered}
                />
              }></Route>
              <Route path='secretcode/*' element={
                <SubmitCode
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='lootkeys/*' element={
                <LootKeysLanding
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              {/* <Route path='secretcode/:elementPath/*' element={
                            <ElementView 
                                gameData={gameData}
                                playerData={playerData} 
                                gameElements={gameElements} 
                            />
                        }></Route> */}
              <Route path='marketplace/*' element={
                <PlayerMarketLanding
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                  gameStats={gameStats}
                  teamMembers={teamMembers}
                  myTeams={myTeams}
                  unadjustedPlayerData={unadjustedPlayerData}
                />
              }></Route>
              <Route path='challenges/*' element={
                <PlayerChallenges
                  gameData={gameData}
                  gameStats={gameStats}
                  playerData={playerData}
                  gameElements={gameElements}
                  actionItems={actionItems}
                  myTeams={myTeams}
                  teamMembers={teamMembers}
                />
              }></Route>
              <Route path='teams/*' element={
                <PlayerTeamsView
                  gameData={gameData}
                  playerData={playerData}
                  teamMembers={teamMembers} />
              }></Route>
              <Route path='quests/*' element={
                <PlayerQuestsLanding
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                  myTeams={myTeams}
                  gameStats={gameStats}
                  teamMembers={teamMembers}
                />
              }></Route>

              <Route path='leaderboards/*' element={
                <PlayerLeaderboardsContainer
                  gameData={gameData}
                  gameElements={gameElements}
                  playerData={playerData}
                  playerList={playerList} />
              }></Route>
              <Route path='gameactivity/*' element={
                <PlayerActivity
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements} />
              }></Route>
              <Route path='news' element={
                <PlayerGameNews
                  gameData={gameData}
                  gameMessages={gameMessages} />
              }></Route>
              <Route path='xp/*' element={
                <MyXpEarningsList
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='badges/*' element={
                <MyBadges
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='badges/:elementPath/*' element={
                <ElementView
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='levels/*' element={
                <MyLevelsList
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='levels/:elementPath/*' element={
                <ElementView
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='currency/*' element={
                <MyCurrencyEarningsList
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='currencytotal/*' element={
                <MyCurrencyEarningsList
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                  total={true}
                />
              }></Route>
              <Route path='foundsecretcodes/*' element={
                <MySecretCodesList
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='redeemedlootkeys/*' element={
                <MyLootKeysList
                  gameData={gameData} 
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='completedchallenges/*' element={
                <MyChallengesList
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='completedquests/*' element={
                <MyQuestsList
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='momentumcards/*' element={
                <MyMomentumList
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                />
              }></Route>
              <Route path='transaction/:transPath' element={
                <div className='purchase-details-container'>
                  <div className='purchase-details g-card'>
                    <TransactionView
                      gameData={gameData}
                      gameElements={gameElements}
                      playerList={playerList}
                    />
                  </div>
                </div>
              }></Route>
              <Route path='tradeportal/*' element={
                <TradePortalContainer
                  gameData={gameData}
                  playerData={playerData}
                  gameElements={gameElements}
                  playerList={playerList}
                  unadjustedPlayerData={unadjustedPlayerData} />
              }></Route>
              <Route path='*' element={<Navigate replace to="/404" />}></Route>
            </Routes>
          </div>
        </>
      }
      <NewRewardModal
        gameData={gameData}
        gameElements={gameElements}
        playerData={playerData}
      />
      <DeclinedChallengeModal
        gameData={gameData}
        playerData={playerData}
        gameElements={gameElements}
      />
      <MomentumRevealModal
        gameData={gameData}
        playerData={playerData}
        gameElements={gameElements}
        playerList={playerList}
        pendingId={momentumRevealQueue[0] ?? null}
        onDismiss={handleMomentumDismiss}
      />
      <TradeOfferNotificationModal
        gameData={gameData}
        playerData={playerData} />
      {/* <AcceptedItemModal gameData={gameData} playerData={playerData} playerActivity={playerActivity} gameElements={gameElements}/> */}
      {
        (screenSize === 'mobile' ||
          screenSize === 'tablet') &&
        <div className='mobile-bottom-spacer'></div>
      }
    </div>
  )
}

export default PlayerGameContent